module.exports = __webpack_public_path__ + "media/outside-world.8cb8020e.mp3";